/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Mesh, MeshStandardMaterial } from 'three';
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader';
import { Orientation } from '../Orientation';
import { CapNames } from '../CapNames';
import { Materials } from '../../materials/Materials';
/**
 * Capability to draw STL Files
 */
export class FileStlCap {
    getName() {
        return CapNames.STLFILE;
    }
    call(objectIn, sceneIn) {
        const payload = objectIn.payload;
        if (!!payload && !!payload.stlFile) {
            const _material = !!objectIn.materials && objectIn.materials.length === 1 ? objectIn.materials[0] : undefined;
            const material = Materials.create(_material, sceneIn) || new MeshStandardMaterial();
            const loader = new STLLoader();
            loader.load(payload.stlFile, (geometry) => {
                const obj = new Mesh(geometry, material);
                obj.name = objectIn.name;
                Orientation.set(obj, objectIn);
                sceneIn.add(obj);
            });
            return true;
        }
        return false;
    }
}
//# sourceMappingURL=FileStlCap.js.map